// type => český název
export const categoryMap = {
    workers: "Pracovníci",
    users: "Uživatelé",
    tech: "Technika",
    favourites: "Uložené nabídky",
    jobs: "Práce",

    light_technician: "Osvětlovač",
    sound_technician: "Zvukař",
    av_technician: "AV technik",
    rigger: "Rigger",
    stagehands: "Stagehands",
    light: "Světla",
    sound: "Zvuk",
    video: "Video",
    rigging_stage: "Rigging & Stage",
    scenography: "Scénografie",
};
